









import { Component, Prop, Vue } from 'vue-property-decorator';
import { IProduct, PolicyFilter } from 'admiral-core';
import { PreferencesAction } from '@/store/PreferencesModule';

@Component({
  components: {},
})
export default class PolicyProductLink extends Vue {
  @Prop({ type: Object })
  product!: IProduct;

  @Prop({ type: Boolean, default: () => true })
  isActive!: boolean;

  get filter() {
    return this.$store.state.PreferencesModule.policyFilter;
  }

  async handleClick(event: MouseEvent) {
    if (!this.isActive) {
      return false;
    }
    const filter = (await this.$store.getters['PreferencesModule/getPolicyFilter']) as PolicyFilter;
    if (filter.products!.find((product: IProduct) => product.id === this.product.id)) {
      filter.products = [];
    } else {
      filter.products = [this.product];
    }
    await this.$store.dispatch(`PreferencesModule/${PreferencesAction.setPolicyFilter}`, filter);
  }

  title() {
    if (this.filter.products!.find((product: IProduct) => product.id === this.product.id)) {
      return 'Filter entfernen';
    } else {
      return `Filter setzen`;
    }
  }
}
